import { QuestionNumericUnits } from '@/api/generated-catch-backend/model';

interface NumberInputProps {
  value: string;
  onChange: (value: string) => void;
  units: QuestionNumericUnits;
  placeholder?: string;
  error?: string;
  required?: boolean;
  min?: number;
  max?: number;
}

export const NumberInputUnits = ({
  value,
  onChange,
  placeholder,
  error,
  required,
  min,
  max,
  units,
}: NumberInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      e.currentTarget.blur();
    }
  };

  const hasValue = value && value.trim() !== '';

  return (
    <div className="questionnaire-question-content">
      <div className="input-field-number-units-container">
        {/* Background container */}
        <div className="input-background" />

        {!hasValue && (
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4">
            <span className="text-gray-400" style={{ fontSize: '14px' }}>
              {placeholder ?? 'e.g. 10'}
            </span>
          </div>
        )}

        {units && (
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4">
            <span
              className={`transition-colors duration-200 ${hasValue ? 'text-black' : 'text-gray-400'}`}
              style={{ fontSize: '14px' }}
            >
              {units}
            </span>
          </div>
        )}

        <input
          type="number"
          value={value}
          step="any"
          inputMode="numeric"
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          className={`input-field-number ${error ? 'input-field-error' : ''} pointer-events-auto bg-transparent`}
          style={{
            paddingLeft: '16px',
            paddingRight: units ? '45px' : '16px',
          }}
        />
      </div>
    </div>
  );
};
